export default __webpack_public_path__ + "static/media/ic_matic_24.4352380c.svg";